export const socialsData = {
    github: 'https://github.com/SIMRAT007',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/simratsingh007/',
    instagram: 'https://www.instagram.com/simrat_singh_mehra/',
    codepen: '',
    twitter: 'https://twitter.com/SIMRAT_07',
    reddit: '',
    blogger: 'https://simratsinghtechnodiary.blogspot.com/',
    medium: '',
    stackOverflow: '',
    gitlab: '',
    youtube: '',
    whatsapp: 'https://api.whatsapp.com/send?phone=7209803944&text=Heyaa!%20Simrat%20Singh%20this%20side,%20Thanks%20for%20consideration.%20I%20will%20contact%20you%20soon,%20leave%20your%20message.%20Have%20a%20good%20day%20!',
    gmail :'mailto:simrat.luvn.100@gmail.com'
}